/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Dropdown,
  Input,
  Popover,
  Row,
  Select,
  Modal,
  Collapse,
  Tooltip,
  FloatButton,
  Image,
  Typography,
  Switch,
  Table,
  Radio,
  Skeleton,
  // Skeleton,
} from "antd";
import {
  FileTextOutlined,
  ProductFilled,
  // UpOutlined,
  // ScanOutlined,
  // EditFilled,
  DownOutlined,
  SettingOutlined,
  // SearchOutlined,
  // CloseCircleOutlined,
  PlusOutlined,
  DeleteOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  ArrowsAltOutlined,
  EyeInvisibleFilled,
  DownCircleOutlined,
  QuestionCircleOutlined,
  EyeFilled,
  FileExcelOutlined,
} from "@ant-design/icons";
import "./index.css";
import { HeaderData, itemHeaders, partyFaqList } from "./data";
import customModalLogo from "../../assets/images/custom-field-banner.webp";
import itemsLogo from "../../assets/images/items-empty-state.svg";
import { Prompt, useHistory } from "react-router";
import CreateItems from "./items";
import useBeforeUnload from "../../components/Prompting";
import { isEmpty, parseInt } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
  adjustStockList,
  // createCategoryList,
  deleteItemList,
  // loadCategory,
  loadItems,
  loadItemsRecordsMetaData,
  loadStockValueList,
} from "../../store/items/actions";
import { toast, ToastContainer } from "react-toastify";
// import SimpleReactValidator from "simple-react-validator";
import { Link } from "react-router-dom";
import { BiRightArrowAlt } from "react-icons/bi";

const Items = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  //validations
  // const simpleValidator = useRef(new SimpleReactValidator());
  // const [, forceUpdate] = useState();

  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);

  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const profileName =
    props.location && props.location.state
      ? props.location.state.user.organizations[0].organizationId
      : "";
  // console.log(profileName, "profileName");

  const organizationId = !isEmpty(userInfoDetails)
    ? userInfoDetails
    : profileName;
  const itemList = { organizationId: organizationId };

  //api loader
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 2000);
    dispatch(loadItems(itemList));
    // dispatch(loadCategory(itemList));
    dispatch(loadStockValueList(itemList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const {
    items_list = [],
    // category_list = [],
    stock_value_list = {},
  } = useSelector((state) => state.Items);

  // const categoryOptions =
  //   category_list.length > 0
  //     ? category_list.map((c) => {
  //         return {
  //           label: c.categoryName,
  //           shortCode: c.shortCode,
  //           value: c._id,
  //         };
  //       })
  //     : [];

  // console.log(items_list, "items_list");
  // const [categoryName, setCategoryName] = useState("");
  // const [categoryAdditionalFields, setCategoryAdditionalFields] = useState("");
  // const [description, setDescription] = useState("");
  // const [shortCode, setShortCode] = useState("");
  // const [itemCategory, setItemCategory] = useState([]);
  // const [itemCategoryModal, setItemCategoryModal] = useState(false);

  const [itemsTab, setItemsTab] = useState("");
  // const [searchOpen, setSearchOpen] = useState(false);
  const [pageRouting, setPageRouting] = useState(false);

  //Custom Fields State values
  const [customFields, setCustomFields] = useState(false);
  const [itemSettings, setItemSettings] = useState(false);
  // const [categoryChange, setCategoryChange] = useState(false);
  // const [customFieldsAdd, setCustomFieldsAdd] = useState(false);
  const [pageRender, setPageRender] = useState(false);
  // const [addItemsShow, setAddItemsShow] = useState(false);
  const [invoiceShow, setInvoiceShow] = useState(false);
  const [showLowStock, setShowLowStock] = useState(false);
  const [stockValue, setStockValue] = useState([]);
  const [itemBatching, setItemBatching] = useState("");
  const [beforeExpiry, setBeforeExpiry] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [validity, setValidity] = useState([]);
  const [serialNumberFields, setSerialNumberFields] = useState("");

  const handleOk = () => {
    setCustomFields(false);
  };
  const handleCancel = () => {
    setCustomFields(false);
  };

  const [customFieldsData, setCustomFieldsData] = useState([
    {
      fieldName: "",
    },
  ]);

  const addCustomFields = () => {
    setCustomFieldsData([
      ...customFieldsData,
      {
        fieldName: "",
      },
    ]);
    // setCustomFieldsAdd(true);
    setPageRender(!pageRender);
  };

  const removeCustomFields = (index) => {
    const array = customFieldsData;
    if (index !== 0) {
      if (index > -1) {
        array.splice(index, 1);
      }
    }
    setPageRender(!pageRender);
  };

  const handleCustomFieldsChange = (e, name, index) => {
    var fieldList = customFieldsData;
    if (name === "fieldName") {
      fieldList[index][name] = e.target.value;
      setCustomFieldsData(fieldList);
      setPageRender(!pageRender);
    }
  };

  //Item creations State values
  const [createItemModal, setCreateItemModal] = useState(false);
  const [itemCreated, setItemCreated] = useState(false);
  const [deleteItemModal, setDeleteItemModal] = useState(false);
  const [partyFaq, setPartyFaq] = useState(false);

  const handleClose = (data) => {
    setCreateItemModal(data);
    // console.log(data, "data");
  };
  useEffect(() => {
    setStockValue({
      value: "Purchase Price",
      label: "Purchase Price",
    });
    setSerialNumberFields("IMEI/Serial No");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const itemsRoutes = (data) => {
    history.push({
      pathname: "/items/data",
      state: data,
    });
  };

  const handleItemCreate = (data) => {
    setItemCreated(data);
  };

  const [itemRows, setItemRows] = useState([
    {
      itemName: "",
      itemNameValue: "",
      brandId: "",
      brandName: "",
      itemCode: "",
      salesPrice: "",
      purchasePrice: "",
      categoryId: "",
      categoryName: "",
      stockQTY: "",
      batchDetails: "",
      createdAt: "",
      createdBy: "",
      customFields: "",
      gstPercentageId: "",
      image: "",
      isProduct: "",
      isService: "",
      measuringId: "",
      serialDetails: "",
      serialMeasuringId: "",
      updatedAt: "",
      _id: "",
      index: "",
      action: "",
      status: "",
    },
  ]);

  const [search, setSearch] = useState("");

  ////adjust stock
  const [adjustStock, setAdjustStock] = useState(false);
  const [adjustStockValidations, setAdjustStockValidations] = useState(false);

  const [adjustStockData, setAdjustStockData] = useState({
    adjustQuantity: "",
    adjustRemarks: "",
    itemName: "",
    _id: "",
    stockQuantity: "",
  });
  const [adjustMode, setAdjustMode] = useState("");
  const handleAdjustChange = (e) => {
    setAdjustStockData({
      ...adjustStockData,
      [e.target.name]: e.target.value,
    });
  };

  const itemsDataTable =
    items_list && items_list.length > 0
      ? items_list.map((data, index) => {
          // const categoryName =
          //   categoryOptions && categoryOptions.length > 0
          //     ? categoryOptions.find(
          //         (category) => category.value === data.categoryId
          //       )
          //     : "";

          // const categoryNameValue = !isEmpty(categoryName)
          //   ? categoryName.label
          //   : "";
          return {
            index: index + 1,
            itemName: (
              <h1 onClick={() => itemsRoutes(data)}>{data.itemName}</h1>
            ),
            itemNameValue: data.itemName,
            brandId: data.brandId,
            brandName: data.brandName,
            _id: data._id,
            itemCode: (
              <h1 onClick={() => itemsRoutes(data)}>
                {" "}
                {data.itemCode ? data.itemCode : "--"}
              </h1>
            ),
            salesPrice: (
              <h1 onClick={() => itemsRoutes(data)}>
                {data.salesPrice
                  ? "₹ " +
                    parseFloat(data.salesPrice).toFixed(2).toLocaleString()
                  : "₹ " + 0}
              </h1>
            ),
            purchasePrice: (
              <h1 onClick={() => itemsRoutes(data)}>
                {data.purchasePrice
                  ? "₹ " +
                    parseFloat(data.purchasePrice).toFixed(2).toLocaleString()
                  : "₹ " + 0}
              </h1>
            ),
            stockQTY: (
              <h1 onClick={() => itemsRoutes(data)}>
                {data.noofStock ? data.noofStock + " PCS" : "--"}
              </h1>
            ),
            batchDetails: data.batchDetails,
            createdAt: data.createdAt,
            createdBy: data.createdBy,
            customFields: data.customFields,
            categoryId: data.categoryId,
            categoryName: data.categoryName,
            // categoryNameValue: categoryNameValue,
            gstPercentageId: data.gstPercentageId,
            gstPercentageName: data.gstPercentageName,
            serialMeasuringId: data.serialMeasuringId,
            serialMeasuringName: data.serialMeasuringName,
            image: data.image,
            // itemNameValue: data.itemName,
            itemCodeValue: data.itemCode,
            salesPriceValue: data.salesPrice,
            purchasePriceValue: data.purchasePrice,
            stockQTYValue: data.noofStock,
            categoryIdValue: data.categoryId,
            descriptionValue: data.description,
            // categoryNameValue: data.categoryName,
            isProduct: data.isProduct,
            isService: data.isService,
            measuringId: data.measuringId,
            description: data.description,
            serialDetails: data.serialDetails,
            // serialMeasuringId: data.serialMeasuringId,
            updatedAt: data.updatedAt,
            action: (
              <ProductFilled
                className="text-[18px]"
                onClick={() => {
                  setAdjustMode("Add");
                  setAdjustStockData({
                    ...adjustStockData,
                    itemName: data.itemName,
                    stockQuantity: data.noofStock,
                    adjustQuantity: "",
                    adjustRemarks: "",
                    _id: data._id,
                  });
                  setAdjustStock(true);
                }}
              />
            ),
            status: data.status,
          };
        })
      : [];

  useEffect(() => {
    if (itemsDataTable && itemsDataTable.length > 0) {
      setItemRows(itemsDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items_list]);
  //data table

  // console.log(itemsDataTable, "itemsDataTable");

  const totalStockValue =
    stock_value_list && stock_value_list
      ? stock_value_list.totalStockValue
      : "";

  const stockReportRoutes = (data) => {
    history.push({
      pathname: "/stock-summary-report",
      state: {
        mode: data.label,
        itemList: itemList,
        // categoryOptions: categoryOptions,
        stockValue: totalStockValue,
      },
      // state: {

      //   // stockValue: stockValue
      // },
    });
  };

  const handleSearch = (event) => {
    const filteredRows = itemsDataTable
      .filter((row) =>
        row.itemNameValue
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setItemRows(filteredRows);
    setShowLowStock(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [deleteItemButtonDisabled, setDeleteItemButtonDisabled] = useState([]);

  const hasSelected = selectedRowKeys.length > 0;

  //category api integrations
  const deleteItems = () => {
    setDeleteItemButtonDisabled(true)
    setTimeout(()=> {
      setDeleteItemButtonDisabled(false)
    }, 3000)
    const itemListData = {
      organizationId: organizationId,
      itemId:
        selectedRowKeys.length > 0 ? selectedRowKeys.map((data) => data) : "",
      deletedBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
    };
    dispatch(deleteItemList(itemListData));
    setTimeout(() => {
      dispatch(loadItems(itemList));
      setDeleteItemModal(false);
      toast.error("Items Deleted Successfully");
    }, 1000);
  };

  //category api integrations
  // const createCategory = () => {
  //   if (simpleValidator.current.allValid()) {
  //     const categoryList = {
  //       categoryName: categoryName,
  //       organizationId: organizationId,
  //       shortCode: shortCode,
  //       description: description,
  //       createdBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
  //     };

  //     dispatch(createCategoryList(categoryList));
  //     setTimeout(() => {
  //       dispatch(loadCategory(itemList));
  //       setItemCategoryModal(false);
  //       toast.success("Category Created Successfully");
  //     }, 1000);
  //   } else {
  //     simpleValidator.current.showMessages();
  //     forceUpdate(1);
  //   }
  // };

  const stockQuantity = parseFloat(adjustStockData.stockQuantity);
  const adjustQuantity = parseFloat(adjustStockData.adjustQuantity);

  const finalStock = stockQuantity + adjustQuantity;

  const finalStockReduceValue =
    adjustStockData.adjustQuantity &&
    adjustStockData.stockQuantity &&
    adjustMode === "Reduce"
      ? parseInt(adjustStockData.stockQuantity - adjustStockData.adjustQuantity)
      : adjustStockData.adjustQuantity &&
        isEmpty(adjustStockData.stockQuantity) &&
        adjustMode === "Reduce"
      ? stockQuantity
      : "";

  const finalStockAddValue =
    adjustStockData.adjustQuantity &&
    adjustStockData.stockQuantity &&
    adjustMode === "Add"
      ? finalStock
      : adjustStockData.adjustQuantity &&
        isEmpty(adjustStockData.stockQuantity) &&
        adjustMode === "Add"
      ? adjustQuantity
      : "";

  //items stock integrations
  const adjustStockDetails = () => {
    if (!isEmpty(adjustStockData.adjustQuantity)) {
      const stockList = {
        itemId: adjustStockData._id,
        organizationId: organizationId,
        isAdd: adjustMode === "Add" ? true : false,
        isReduce: adjustMode === "Reduce" ? true : false,
        quantity:
          adjustMode === "Reduce"
            ? finalStockReduceValue
            : adjustMode === "Add"
            ? finalStockAddValue
            : 0,
      };

      dispatch(adjustStockList(stockList));
      setTimeout(() => {
        dispatch(loadItems(itemList));
        setAdjustStock(false);
        setSelectedRowKeys([]);
        setAdjustStockValidations(false);
        toast.success("Stocks Updated Successfully");
      }, 1000);
    } else {
      setAdjustStockValidations(true);
    }
  };

  //api loader
  useEffect(() => {
    if (itemCreated === true) {
      dispatch(loadItems(itemList));
      setItemCreated(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemCreated]);
  useBeforeUnload({
    when: !isEmpty(search),
    message: "Are you sure you want to leave?",
  });

  const items = [
    // {
    //   label: <Link to={{ pathname: "/items" }}>Rate List</Link>,
    //   key: "1",
    // },
    // {
    //   type: "divider",
    // },
    {
      label: (
        <Link to={{ pathname: "/reports/stock-details-report" }}>
          Stock Summary
        </Link>
      ),
      key: "1",
    },
    {
      type: "divider",
    },
    // {
    //   label: <Link to={{ pathname: "/reports/sales-item-quantity-report" }}>Low Stock Summary</Link>,
    //   key: "2",
    // },
    // {
    //   type: "divider",
    // },
    {
      label: (
        <Link to={{ pathname: "/reports/sales-summary-report" }}>
          Item Sales Summary
        </Link>
      ),
      key: "2",
    },
  ];

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Items | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        {/* <Skeleton.Input
          style={{
            padding: "5px",
            width: "100%",
          }}
          active={true}
          size={"large"}
        > */}
        <FloatButton
          className="w-[50px] h-[50px]"
          type="primary"
          style={{
            margin: "-31px -12px",
          }}
          onClick={() => setPartyFaq(!partyFaq)}
          icon={<QuestionCircleOutlined />}
        />
        <Col span={24}>
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-2">
            <div className="flex">
              <ArrowLeftOutlined
                onClick={() => setPageRouting(true)}
                className="font-bold text-[18px]"
              />
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[18px] ml-2 mt-2 font-semibold"
              >
                Items
              </h1>
            </div>
            <div className="flex">
              <Dropdown
                menu={{
                  items,
                }}
                trigger={["click"]}
                className="text-[#0c8ce9] rounded-md"
              >
                <Tooltip
                  title="See all your Item specific reports"
                  placement="left"
                  rootClassName="text-[10px]"
                >
                  <div
                    style={{
                      border: "1px solid #9ed1f6",
                      fontFamily: "Poppins",
                    }}
                    className="border flex justify-between w-[180px] pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                  >
                    <div>
                      <FileTextOutlined /> Reports
                    </div>
                    <DownOutlined />
                  </div>
                </Tooltip>

                {/* </a> */}
              </Dropdown>
              <Tooltip
                title="Use advanced settings to customise items to your needs"
                placement="bottom"
                rootClassName="text-[10px]"
                style={{
                  cursor: "not-allowed",
                }}
              >
                <div
                  style={{
                    // cursor: "not-allowed",
                    pointerEvents: "none",
                  }}
                  onClick={() => setItemSettings(true)}
                  className="opacity-1 bg-[#efefef] border rounded-md ml-3 p-2.5"
                >
                  <SettingOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        </Col>
        {/* </Skeleton.Input> */}
        <div
          className={
            windowDimensions.height >= 650 && windowDimensions.height < 700
              ? "items-home-tab-device-main-card"
              : (windowDimensions.height >= 700 &&
                  windowDimensions.height <= 767) ||
                (windowDimensions.height > 767 && windowDimensions.height < 830)
              ? "items-home-medium-device-main-card"
              : windowDimensions.height >= 800 && windowDimensions.height < 900
              ? "items-home-large-device-main-card"
              : windowDimensions.height >= 900 && windowDimensions.height < 1000
              ? "items-home-extra-large-device-main-card"
              : windowDimensions.height >= 1000
              ? "items-home-extra-infinite-large-device-main-card"
              : "items-home-main-card"
          }
        >
          <Col span={24}>
            <Row className="pl-5 mt-3 mb-5">
              {itemHeaders.map((data) => {
                return (
                  <Col
                    span={12}
                    key={data.key}
                    className=""
                    onClick={() => {
                      stockReportRoutes(data);
                    }}
                  >
                    {loading ? (
                      <Skeleton.Input
                        style={{
                          marginRight: "5px",
                          width: "250%",
                          height: "60px",
                        }}
                        active={true}
                        size={"large"}
                        // block={true}
                      ></Skeleton.Input>
                    ) : (
                      <div
                        className={
                          itemsTab === data.label
                            ? "poppins mr-4 items-select-card items-card border rounded-md"
                            : "poppins mr-4 items-card border rounded-md"
                        }
                        onClick={() => setItemsTab(data.label)}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            display: "flex",
                            justifyContent: "space-between",
                            color: data.color,
                            fontFamily: "Poppins",
                          }}
                        >
                          <div className="flex mt-[-10px]">
                            <p className="mt-1">{data.icon}</p>
                            <h2 className={"ml-2 mt-1"}>{data.label}</h2>
                          </div>
                          <ArrowsAltOutlined className="text-[brown]" />
                        </div>
                        <div className="mt-2">
                          <h1 className="font-semibold text-[18px]">
                            {data.key == 1 ? data.amount : data.items}
                          </h1>
                        </div>
                      </div>
                    )}
                    {/* </Skeleton.Input> */}
                  </Col>
                );
              })}
            </Row>
          </Col>
          {/* items input section with bulk actions */}
          <Col span={24}>
            <Row className="flex justify-between ml-4">
              <div className="flex">
                {loading ? (
                  <Skeleton.Input
                    style={{
                      marginRight: "5px",
                      width: "100%",
                      height: "40px",
                    }}
                    className="parties-card"
                    active={true}
                    size={"large"}
                    // block={true}
                  ></Skeleton.Input>
                ) : (
                  <>
                    <Tooltip
                      rootClassName="text-[10px]"
                      title="Search by phone or name"
                      placement="bottom"
                    >
                      {/* {searchOpen ? ( */}
                      <AutoComplete
                        // options={options}
                        style={{
                          width: 170,
                          marginRight: "10px",

                          fontFamily: "Poppins",
                        }}
                        // onSelect={onSelect}
                        // onSearch={(text) => setOptions(getPanelValue(text))}
                      >
                        <Input.Search
                          size="large"
                          placeholder="Search Item"
                          style={{
                            fontFamily: "Poppins",
                          }}
                          name="search"
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete>
                      {/* ) : (
                        <div
                          onClick={() => setSearchOpen(true)}
                          className="border rounded-md h-[40px] mr-3 pt-2 pb-2 pr-3 pl-3 cursor-pointer"
                        >
                          <SearchOutlined size={16} />
                        </div>
                      )} */}
                    </Tooltip>

                    {/* <Select
                      style={{
                        width: 220,
                        height: 40,
                      }}
                      value={itemCategory}
                      onChange={(e) => {
                        setItemCategory(e);
                        // console.log(e, "category");
                        if (!isEmpty(e)) {
                          const filterRows =
                            itemRows.length > 0 &&
                            itemRows.filter((data) => data.categoryId === e);
                          // console.log(filterRows, "filterRows");
                          const filteredData =
                            filterRows.length > 0 && filterRows;
                          setItemRows(filteredData);
                          // setShowLowStock(true);
                          setCategoryChange(true);
                          setTableLoading(true);
                          setTimeout(() => {
                            setTableLoading(false);
                          }, 2000);
                        }
                      }}
                      suffixIcon={
                        !isEmpty(itemCategory) ? (
                          <CloseCircleOutlined
                            onClick={() => {
                              setItemCategory([]);
                              setItemRows(itemsDataTable);
                              setTableLoading(true);
                              setTimeout(() => {
                                setTableLoading(false);
                              }, 1000);
                            }}
                            className="text-[12px]"
                          />
                        ) : (
                          <SearchOutlined className="text-[12px]" />
                        )
                      }
                      onSearch={true}
                      placeholder="Select Categories"
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <Divider
                            style={{
                              margin: "8px 0",
                            }}
                          />
                          <div className="w-[100%]">
                            <Button
                              type="dashed"
                              className="w-[100%]"
                              icon={<PlusOutlined />}
                              onClick={() => {
                                setItemCategoryModal(true);
                                setCategoryAdditionalFields(false);
                              }}
                            >
                              Add item
                            </Button>
                          </div>
                        </>
                      )}
                      options={categoryOptions}
                    /> */}
                  </>
                )}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      marginRight: "5px",
                      width: "100%",
                      height: "40px",
                    }}
                    className="parties-card"
                    active={true}
                    size={"large"}
                    // block={true}
                  ></Skeleton.Input>
                ) : (
                  <Tooltip
                    title="Show or Hide a items with low stock"
                    placement="left"
                    rootClassName="text-[10px] mt-2"
                  >
                    <div
                      onClick={() => setShowLowStock(!showLowStock)}
                      className="border ml-2 w-[150px] rounded-sm flex justify-between w-[150px] pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                      style={{
                        fontFamily: "Poppins",
                      }}
                    >
                      <div>
                        <ProductFilled /> Show Low Stock
                      </div>
                    </div>
                  </Tooltip>
                )}
              </div>

              <div className="flex">
                {selectedRowKeys.length > 0 ? (
                  <div
                    onClick={() => setDeleteItemModal(true)}
                    className="cursor-pointer border border-1 p-[10px] rounded-md"
                  >
                    <DeleteOutlined className="text-[#eb4e50] text-[18px]" />
                  </div>
                ) : (
                  ""
                )}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      marginRight: "5px",
                      width: "100%",
                      height: "40px",
                    }}
                    className="parties-card"
                    active={true}
                    size={"large"}
                    // block={true}
                  ></Skeleton.Input>
                ) : (
                  <Popover
                    placement="bottomRight"
                    trigger={"click"}
                    // className="h-[100%] p-1"
                    content={
                      //import invoice

                      <div>
                        <div
                          onClick={() =>
                            history.push({
                              pathname: "/items/import",
                              // state: { mode: "IMEI" },
                            })
                          }
                          className="hover:rounded-md hover:bg-[lightgray] hover:mr-[-3px] flex justify-between w-[272px] h-[45px] mt-[2px] pl-3 pr-2 pb-12 cursor-pointer"
                        >
                          <div>
                            <p className="flex text-[14px] font-semibold">
                              <FileExcelOutlined className="mr-2" /> Bulk Import
                              Items
                            </p>
                            <p className="mt-1 text-[12px]">
                              Quickly add all your Item Details with Excel
                            </p>
                          </div>
                          <BiRightArrowAlt size={24} />
                        </div>
                        {/* <div
                          onClick={() =>
                            history.push({
                              pathname: "/purchase-invoice/import",
                              state: { mode: "Qty" },
                            })
                          }
                          className="border border-b-0 border-x-0 border-t-1 hover:bg-[lightgray] hover:rounded-md hover:mr-[-3px] flex justify-between w-[270px] h-[55px] mt-[10px] mb-1 pl-3 pr-2 pt-2 pb-8 cursor-pointer"
                        >
                          <div>
                            <p className="flex text-[14px] font-semibold">
                              <FileExcelOutlined className="mr-2" /> Bulk Import
                              Qty
                            </p>
                            <p className="mt-1 text-[12px]">
                              Quickly add all your Qty details with Excel
                            </p>
                          </div>
                          <BiRightArrowAlt size={24} />
                        </div> */}
                      </div>

                      // <div
                      //   style={{
                      //     fontFamily: "Poppins",
                      //   }}
                      //   className={
                      //     addItemsShow === true ? "h-[250px]" : "h-[150px]"
                      //   }
                      // >
                      //   <div className="hover:rounded-md hover:mr-[-3px] w-[270px] h-[45px] pl-3 pr-2 pt-2 pb-2 cursor-pointer">
                      //     <div className="flex justify-between hover:rounded-md">
                      //       <div
                      //         className="flex"
                      //         onClick={() => setAddItemsShow(!addItemsShow)}
                      //       >
                      //         <p className="  mt-2 border rounded-md border-1 mr-2 h-[40px] p-2 pl-3 pr-3 bg-[lightgray] font-semibold">
                      //           <PlusOutlined className="text-[14px]" />
                      //         </p>
                      //         <p className="mt-1 text-[12px]">
                      //           <p className="text-[14px] font-semibold">
                      //             {" "}
                      //             Add Items
                      //           </p>
                      //           Quickly add all your Items at once
                      //         </p>
                      //       </div>
                      //       {addItemsShow === true ? (
                      //         <DownOutlined
                      //           className="text-[12px] ml-2"
                      //           onClick={() => setAddItemsShow(false)}
                      //         />
                      //       ) : (
                      //         <UpOutlined
                      //           className="text-[12px] ml-2"
                      //           onClick={() => setAddItemsShow(true)}
                      //         />
                      //       )}
                      //     </div>

                      //     {addItemsShow ? (
                      //       <div className="pl-[40px] mt-6">
                      //         {/* <h1>Bulk Add Items</h1> */}
                      //         <div className="flex mt-[-10px] hover:bg-gray-100 hover:mr-[-3px] ">
                      //           <ScanOutlined />
                      //           <h1 className="ml-2">Purchase Bill Upload</h1>
                      //         </div>
                      //         <Divider
                      //           style={{
                      //             width: "140%",
                      //             marginLeft: "-64px",
                      //           }}
                      //         />
                      //         <div className="mt-[-10px] flex hover:bg-gray-100 hover:mr-[-3px]">
                      //           <ProductFilled />
                      //           <h1 className="ml-2">Product Library</h1>
                      //         </div>
                      //       </div>
                      //     ) : (
                      //       ""
                      //     )}
                      //   </div>
                      //   <div
                      //     className={addItemsShow === true ? "mt-[127px]" : ""}
                      //   >
                      //     <Divider
                      //       style={{
                      //         width: "109%",
                      //         marginLeft: "-12px",
                      //       }}
                      //     />
                      //     <div
                      //       className={
                      //         addItemsShow === true
                      //           ? "mt-[-20px] hover:rounded-md hover:bg-gray-100 hover:mr-[-3px] hover:h-[70px] flex justify-between w-[270px] h-[45px] mt-[-12px] pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                      //           : "hover:rounded-md hover:mr-[-3px] hover:h-[70px] hover:bg-gray-100  flex justify-between w-[270px] h-[45px] mt-[-12px] pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                      //       }
                      //     >
                      //       <div className="flex">
                      //         <p className="border pl-3 pr-3 border-1 rounded-md mr-2 h-[40px] p-2 bg-[lightgray] font-semibold">
                      //           <EditFilled className="text-[14px]" />
                      //         </p>
                      //         <p className="mt-1 text-[12px]">
                      //           <p className="text-[14px] font-semibold">
                      //             Bulk Edit
                      //           </p>
                      //           Select Multiple items and edit them at once
                      //         </p>
                      //       </div>
                      //     </div>
                      //   </div>
                      // </div>
                    }
                  >
                    <Tooltip
                      title="Easily perform bulk actions on all your items"
                      placement="left"
                      rootClassName="text-[10px]"
                    >
                      <div
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="border ml-2 w-[150px] rounded-sm flex justify-between w-[150px] pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                      >
                        <div>
                          <FileTextOutlined /> Bulk Action
                        </div>
                        <DownOutlined />
                      </div>
                    </Tooltip>
                  </Popover>
                )}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      marginLeft: "5px",
                      marginRight: "10px",
                      width: "100%",
                      height: "40px",
                      paddingRight: "20px",
                    }}
                    className="parties-card"
                    active={true}
                    size={"large"}
                    // block={true}
                  ></Skeleton.Input>
                ) : (
                  <Button
                    onClick={() => {
                      setCreateItemModal(true);
                      dispatch(loadItemsRecordsMetaData());
                    }}
                    // href="/add-items"
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="ml-3 bg-[blueviolet] p-5 text-[white] mr-3"
                  >
                    Create Item
                  </Button>
                )}
              </div>
            </Row>
          </Col>
          {/* {showLowStock || (!isEmpty(search) && showLowStock) ? ( */}
          <Col span={24} className="p-4">
            {hasSelected ? (
              <Row>
                <Col
                  style={{
                    fontFamily: "Poppins",
                    color: "#ffffff",
                    background: "#4096ff",
                    borderRadius: "10px",
                    padding: "4px 8px",
                  }}
                  className="mb-2"
                  span={4}
                >
                  {hasSelected
                    ? `Selected ${selectedRowKeys.length} items`
                    : ""}
                </Col>
              </Row>
            ) : (
              ""
            )}

            <Table
              style={{
                overflow: "hidden",
                cursor: "pointer",
              }}
              bordered
              columns={HeaderData}
              dataSource={
                (itemRows &&
                  itemRows.length > 0 &&
                  !isEmpty(itemRows[0].itemNameValue)) ||
                search
                  ? // ||
                    // categoryChange
                    itemRows
                  : []
              }
              sortDirections={"ascend"}
              // onHeaderRow={}
              loading={tableLoading ? true : false}
              rowKey={(record) => record._id}
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20", "30"],
              }}
              rowSelection={{
                selectedRowKeys,
                onSelectAll: (selectedRowKeys, selectedRows, row) => {
                  // console.log(selectedRows, "selectedRows");

                  const newSelecteds = selectedRows.map((n) => n._id);
                  setSelectedRowKeys(newSelecteds);
                },
                onSelect: (selectedRowKey, selectedRows, row) => {
                  const selectedIndex = selectedRowKeys.indexOf(
                    selectedRowKey._id
                  );
                  let newSelecteds = [];

                  if (selectedIndex === -1) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys,
                      selectedRowKey._id
                    );
                  } else if (selectedIndex === 0) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(1)
                    );
                  } else if (selectedIndex === selectedRowKeys.length - 1) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(0, -1)
                    );
                  } else if (selectedIndex > 0) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(0, selectedIndex),
                      selectedRowKeys.slice(selectedIndex + 1)
                    );
                  }
                  setSelectedRowKeys(newSelecteds);
                },
              }}
              scroll={{
                y:
                  itemRows.length <= 3
                    ? 150
                    : itemRows.length > 3
                    ? "100%"
                    : "",
                // y:
                //   (windowDimensions.height >= 700 &&
                //     windowDimensions.height <= 767) ||
                //   (windowDimensions.height > 767 &&
                //     windowDimensions.height < 830)
                //     ? 280
                //     : windowDimensions.height > 830
                //     ? 350
                //     : itemRows.length > 2
                //     ? 152
                //     : "",
              }}
              showSorterTooltip={"sorter-icon"}
            />
          </Col>
          {itemRows.length > 0 ? (
            <Col
              span={24}
              className="p-4 mt-[-22px] mb-[40px] flex justify-center"
            >
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className=""
              >
                <Image src={itemsLogo} preview={false} />
                <h1 className="text-center font-semibold mt-2 text-[18px]">
                  Add all your Items at once!
                </h1>
                <p className="text-center text-[12px]">
                  For quicker and easier experience of creating sales invoices
                </p>
              </div>
            </Col>
          ) : (
            ""
          )}
        </div>
        {/* Custom fields modal */}
        <Modal
          open={itemSettings}
          title="Add Custom Fields"
          onOk={() => setItemSettings(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          // okButtonProps={{
          //   disabled: customFieldsData.length > 0 ? false : true,
          // }}
          width={550}
          style={{
            fontFamily: "Poppins",
          }}
          className="mt-[-90px]"
          onCancel={() => setItemSettings(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.1px", width: "110%", marginLeft: "-24px" }}
          />
          <div className="mb-1 flex justify-between mt-[-15px] mb-[-13px]">
            <h1 className="mt-2">Stock Value Calculation</h1>
            <Select
              style={{
                width: 170,
                height: 40,
              }}
              value={stockValue}
              onChange={(e) => setStockValue(e)}
              placeholder=""
              options={[
                {
                  label: "Purchase Price",
                  value: "Purchase Price",
                },
                {
                  label: "Sales Price",
                  value: "Sales Price",
                },
              ]}
            />
          </div>
          <Divider style={{ width: "110%", marginLeft: "-24px" }} />
          <div className="mt-[-15px] flex justify-between">
            <div>
              <h1 className="text-[14px] font-semibold">
                Enable Item Batching & Expiry
              </h1>
              <p className="mt-1 text-[12px]">
                Keep track of multiple prices, expiry and manufacturing dates
              </p>
            </div>
            <Switch
              className="mt-3"
              value={itemBatching}
              onChange={(checked) => setItemBatching(checked)}
            />
          </div>
          {itemBatching === true ? (
            <>
              <div className="mt-[10px] mb-[-13px] flex justify-between">
                <h1 className="text-[14px] font-medium">Alert Before Expiry</h1>
                <Switch
                  className="mt-3"
                  value={beforeExpiry}
                  onChange={(checked) => setBeforeExpiry(checked)}
                />
              </div>
              {beforeExpiry === true ? (
                <div className="mt-[25px] mb-[-13px] flex justify-between">
                  <p className="mt-1 text-[12px]">
                    We will notify you the below selected days before your batch
                    expires
                  </p>
                  <Select
                    style={{
                      width: 120,
                      height: 35,
                    }}
                    value={validity}
                    onChange={(e) => setValidity(e)}
                    placeholder=""
                    suffixIcon={<p className="font-semibold">Days</p>}
                    options={[
                      {
                        label: "30 Days",
                        value: "30 Days",
                      },
                      {
                        label: "60 Days",
                        value: "60 Days",
                      },
                      {
                        label: "90 Days",
                        value: "90 Days",
                      },
                    ]}
                  />
                </div>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          <Divider style={{ width: "110%", marginLeft: "-24px" }} />
          <div className="mb-[-13px] flex justify-between">
            <div>
              <h1 className="text-[14px] font-semibold">
                Enable Serial Number/IMEI
              </h1>
              <p className="mt-1 text-[12px]">
                Manage your items by Serial Number or IMEI and track them easily
              </p>
            </div>
            <Switch
              className="mt-3"
              value={serialNumber}
              onChange={(checked) => setSerialNumber(checked)}
            />
          </div>
          {serialNumber === true ? (
            <div className="mt-[10px]">
              <Typography className="mt-1 text-[#667085] mb-1">
                Field Name
              </Typography>
              <Input
                name="serialNumberFields"
                value={serialNumberFields}
                onChange={(e) => setSerialNumberFields(e.target.value)}
                placeholder="Enter a serial number"
                className="p-3 mt-[10px] w-[50%]"
              />
              <p className="mt-1 text-[12px]">
                Choose a custom field name like IMEI Number, Model Number, Part
                Number etc. for adding the serial numbers.
              </p>
            </div>
          ) : (
            ""
          )}

          <Divider style={{ width: "110%", marginLeft: "-24px" }} />
          <div className="mt-[-15px] mb-[-13px] flex justify-between">
            <h1 className="text-[14px] font-semibold">MRP</h1>
            <Switch className="mt-3" />
          </div>
          <Divider style={{ width: "110%", marginLeft: "-24px" }} />
          <div className="mt-[-15px] mb-[-13px] flex justify-between">
            <h1 className="text-[14px] font-semibold">Wholesale Price</h1>
            <Switch className="mt-3" />
          </div>
          <Divider style={{ width: "110%", marginLeft: "-24px" }} />
          <div className="mt-[-15px] mb-[-13px]">
            {customFieldsData.map((data, index) => {
              return (
                <div key={index} className="mb-2">
                  <div className="flex justify-between mb-[10px]">
                    <h1>{data.fieldName}</h1>
                    <p
                      onClick={() => removeCustomFields(index)}
                      type="primary"
                      className="ml-3 p-2 text-[red] cursor-pointer"
                      size={"large"}
                    >
                      Delete
                    </p>{" "}
                  </div>
                </div>
              );
            })}
          </div>
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Row
            onClick={() => setCustomFields(true)}
            className="w-[100%] mt-2 bg-gray-50 p-2 pl-5 pr-5 mt-3 mb-3"
            style={{
              fontFamily: "Poppins",
            }}
          >
            <h1 className="cursor-pointer text-[14px] text-[#084d7b] font-semibold">
              {" "}
              <PlusOutlined /> Add Custom Field
            </h1>
          </Row>
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
        <Modal
          open={customFields}
          title="Add Custom Fields"
          onOk={handleOk}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: customFieldsData.length > 0 ? false : true,
          }}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <div className="w-[110%] ml-[-23.5px] mt-[-24px] mb-4">
            <Image src={customModalLogo} />
          </div>
          <div>
            <Typography className="text-[#667085] mb-2">Field Name</Typography>
            {customFieldsData.map((data, index) => {
              return (
                <div key={index} className="mb-2">
                  <div className="flex justify-between mb-[10px]">
                    <Input
                      name="fieldName"
                      value={data.fieldName}
                      placeholder="Enter Custom Field name"
                      className="w-[90%]"
                      addonAfter={
                        <>
                          {invoiceShow === true ? (
                            <Tooltip
                              title="Visible in Invoice"
                              placement="left"
                            >
                              <EyeFilled
                                onClick={() => setInvoiceShow(false)}
                              />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Hidden in Invoice" placement="left">
                              <EyeInvisibleFilled
                                onClick={() => setInvoiceShow(true)}
                              />
                            </Tooltip>
                          )}
                        </>
                      }
                      onChange={(e) =>
                        handleCustomFieldsChange(e, "fieldName", index)
                      }
                    />
                    <DeleteOutlined
                      onClick={() => removeCustomFields(index)}
                      type="primary"
                      className="ml-3 border rounded-md p-2 text-[red] cursor-pointer"
                      size={"large"}
                    />{" "}
                  </div>
                </div>
              );
            })}
          </div>
          {/* ) : (
            ""
          )} */}

          <Row
            onClick={() => addCustomFields()}
            className="w-[100%] mt-2 bg-gray-50 p-2 border border-dashed border-blue-400 pl-5 pr-5 mt-3 mb-3"
          >
            <h1 className="cursor-pointer text-[14px] text-[#084d7b] font-semibold">
              {" "}
              <PlusOutlined /> Add Custom Field
            </h1>
          </Row>
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
        {/* party faq modal */}
        <Modal
          open={partyFaq}
          title="Items"
          closeIcon
          maskClosable={false}
          onClose={() => setPartyFaq(false)}
          onCancel={() => setPartyFaq(false)}
          footer={(_, { CancelBtn }) => (
            <>
              <CancelBtn />
            </>
          )}
          width={600}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          />

          <Collapse
            items={partyFaqList}
            expandIcon={<DownCircleOutlined />}
            expandIconPosition="right"
            className="font-semibold"
            bordered
          />
        </Modal>
        <CreateItems
          modalOpen={createItemModal}
          itemCreated={handleItemCreate}
          modalClose={handleClose}
          mode="Add"
        />

        {/* Page routing */}
        <Modal
          open={pageRouting}
          onOk={() => {
            setPageRouting(false);
            history.push("/dashboard");
          }}
          closeIcon
          maskClosable={false}
          okText={"Yes, Leave"}
          cancelText={"No, Stay"}
          onCancel={() => setPageRouting(false)}
          height={300}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <div className="mr-3">
                <OkBtn />
              </div>
              <CancelBtn />
            </div>
          )}
        >
          <div className="text-center w-[100%]">
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to leave this page?
            </h1>
            <p className="text-center text-[14px] mt-2">
              All unsaved changes will be lost!
            </p>
          </div>
        </Modal>
      </Row>
      <Prompt
        when={!isEmpty(search)}
        message="Are you sure you want to leave?"
      />

      {/* Delete item modal */}

      <Modal
        open={deleteItemModal}
        onOk={() => {
          deleteItems();
        }}
        closeIcon
        maskClosable={false}
        okText={`Delete ${
          selectedRowKeys.length > 0 ? selectedRowKeys.length : ""
        } Item`}
        cancelText={"Cancel"}
        okType="danger"
        onCancel={() => setDeleteItemModal(false)}
        height={300}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <CancelBtn />
            <div className="ml-3">
              <OkBtn />
            </div>
          </div>
        )}
      >
        <div className="text-center w-[100%] p-7">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to delete these Items?
          </h1>
          <p className="text-center text-[14px] mt-2">
            The selected Items will be deleted from the Items Inventory. Once
            deleted you will not be able to restore these items.
          </p>
        </div>
      </Modal>
      {/* Adjust Stock Quantity modal */}
      <Modal
        open={adjustStock}
        title="Adjust Stock Quantity"
        onOk={() => {
          adjustStockDetails();
        }}
        closeIcon
        maskClosable={false}
        okText={"Save"}
        width={450}
        className="mt-[-95px]"
        onCancel={() => setAdjustStock(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        )}
      >
        <Divider
          style={{ borderWidth: "0.2px", width: "112%", marginLeft: "-24px" }}
        />

        <Row className="mt-[-10px] mb-[-18px]">
          <Col span={24} className="mb-2">
            <Typography className="mb-1 items-label">Item Name</Typography>
            <h1 className="text-[14px] font-semibold">
              {adjustStockData.itemName}
            </h1>
          </Col>
          <Col span={24} className="mb-2 mt-2">
            <Typography className="mb-2 items-label">
              Add Or Reduce Quantity
            </Typography>

            <Radio.Group
              className="w-[100%]"
              value={adjustMode}
              onChange={(e) => setAdjustMode(e.target.value)}
            >
              <Radio
                style={{
                  fontFamily: "Poppins",
                }}
                value={"Add"}
                className="w-[45%]"
              >
                Add +
              </Radio>
              <Radio
                value={"Reduce"}
                style={{
                  fontFamily: "Poppins",
                }}
                className="w-[45%] ml-2 p-3 rounded-md border border-1"
              >
                Reduce -
              </Radio>
            </Radio.Group>
          </Col>
          <Col span={24} className="mb-2">
            <Typography className="mb-2 items-label">
              Current Stock Level
            </Typography>
            <h1 className="text-[13px]">
              {adjustStockData.stockQuantity
                ? adjustStockData.stockQuantity
                : 0}
            </h1>
          </Col>

          <Col span={24} className="mb-2 pr-2">
            <Typography className="mb-2 items-label">
              Adjust Quantity
            </Typography>
            <Input
              name="adjustQuantity"
              value={adjustStockData.adjustQuantity}
              placeholder="0.0"
              onChange={(e) => handleAdjustChange(e)}
              className="p-2"
              suffix={"PCS"}
            />
            <p className="text-start text-[red] mt-2 mb-3">
              {adjustStockValidations === true
                ? "Adjust Quantity field is required"
                : ""}
            </p>
          </Col>
          <Col span={24} className="mb-2 mt-2 ">
            <Typography className="mb-2 items-label">Final Stocks</Typography>
            <h1 className="text-[13px]">
              {isNaN(finalStockAddValue) || isNaN(finalStockReduceValue)
                ? stockQuantity
                : adjustMode === "Reduce"
                ? finalStockReduceValue
                : adjustMode === "Add"
                ? finalStockAddValue
                : 0}
            </h1>
          </Col>
          <Col span={24} className="mt-2 ">
            <Typography className="mb-2 items-label">Remarks</Typography>
            <Input.TextArea
              name="adjustRemarks"
              value={adjustStockData.adjustRemarks}
              placeholder="Enter Remarks"
              onChange={(e) => handleAdjustChange(e)}
              className="p-2"
              suffix={"PCS"}
            />
          </Col>
        </Row>

        <Divider
          style={{ borderWidth: "0.2px", width: "112%", marginLeft: "-24px" }}
        />
      </Modal>

      {/* New category modal */}
      {/* <Modal
        open={itemCategoryModal}
        title={"Create Category"}
        onOk={() => {
          createCategory();
        }}
        closeIcon
        maskClosable={false}
        okText={"Save"}
        width={450}
        onCancel={() => setItemCategoryModal(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        )}
      >
        <Divider
          style={{
            borderWidth: "0.2px",
            marginTop: "1px",
            width: "112%",
            marginLeft: "-24px",
          }}
        />
        <Col span={24} className="mt-[-5px]">
          <Typography
            className="uppercase mb-1"
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
            }}
          >
            Category Name
          </Typography>
          <Input
            name="categoryName"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            placeholder="Enter Category Name"
            className="p-2"
          />
          <p className="text-start text-[red] mt-2 mb-3">
            {simpleValidator.current.message(
              "categoryName",
              categoryName,
              "required"
            )}
          </p>
        </Col>
        {categoryAdditionalFields ? (
          <>
            {" "}
            <Col span={24} className="flex justify-end">
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                onClick={() => setCategoryAdditionalFields(false)}
                className="cursor-pointer text-[#d54041] text-[13px]"
              >
                Remove
              </div>
            </Col>
            <Col span={24}>
              <Typography
                className="uppercase mb-1"
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                Short Code
              </Typography>
              <Input
                name="shortCode"
                value={shortCode}
                onChange={(e) => setShortCode(e.target.value)}
                placeholder="Enter Short Code"
                className="p-2"
              />
            </Col>
            <Col span={24} className="mb-[50px] mt-2">
              <Typography
                className="uppercase mb-1"
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                Description
              </Typography>
              <Input.TextArea
                name="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter Description"
                className="p-3"
              />
            </Col>
          </>
        ) : (
          <div
            style={{
              fontFamily: "Poppins",
            }}
            onClick={() => setCategoryAdditionalFields(true)}
            className="cursor-pointer flex text-[#4096ff] mt-2 text-[13px] mb-4"
          >
            <PlusOutlined className="mr-2" /> Additonal Fields
          </div>
        )}
      </Modal> */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
          fontFamily: "Poppins",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

Items.propTypes = {
  location: PropTypes.any,
};

export default Items;
